// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
} from '../../../utils/Styles/DataBoxStyles';

const PartyPollsTableMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  polls,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getFormattedCreatedDate,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onCreatorIdClick,
}) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {polls.map(item => (
        <StyledMobileBoxItem key={item.pollId}>
          <StyledMobileBoxItemRow>
            {getFormattedCreatedDate(item)} {item.name}
          </StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow>
            Created By:
            <span onClick={() => onCreatorIdClick(item.creatorId)}>
              {item.creatorId}
            </span>
          </StyledMobileBoxItemRow>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default PartyPollsTableMobile;
